import { useEffect } from 'react'
import { ISalesTeam } from '@user/store/salesTeam'
import { useFormikContext } from 'formik'

interface Props {
  assigneeIds: string[]
  salesTeams: ISalesTeam[]
}

export function useOnBacksideMount(props: Props) {
  const { assigneeIds, salesTeams } = props

  const { setValues, values } = useFormikContext<{
    salesTeamIds: number[]
    assigneeIds: string[]
    numDays?: number
  }>()

  useEffect(() => {
    setValues({
      salesTeamIds: values.salesTeamIds ?? salesTeams.map((team) => team.id),
      assigneeIds: values.assigneeIds ?? (assigneeIds || []),
      numDays: values.numDays,
    })
  }, [setValues, salesTeams, assigneeIds, values.numDays])
}
